import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { Button, IconButton } from '@mui/material'
import { useHeaderStore } from '@/stores/useHeaderStore'

import { downloadBlobAsFile, generateCSVContent } from './utils'

export const DOWNLOAD_CSV_BUTTON_TEST_ID = 'downloadCsv-button' as const
export const DOWNLOAD_CSV_LABEL = 'Download CSV' as const

export type DownloadCsvDataProps<Data extends Record<string, unknown>> = {
  csvHeaders?: string[]
  csvFileName?: string
  data: Data[]
}

type Props<Data extends Record<string, unknown>> = {
  formatCsvRow?: (row: Data) => string[]
  asIcon?: boolean
} & DownloadCsvDataProps<Data>

export const DownloadCsv = <Data extends Record<string, unknown>>({
  csvFileName,
  formatCsvRow,
  csvHeaders,
  data,
  asIcon = false
}: Props<Data>) => {
  const { title } = useHeaderStore()
  const titleSpaceReplacedWithUnderscore = title?.replace(/\s+/g, '_') || 'export'

  const exportToCsV = () => {
    const csvContent = generateCSVContent({
      headers: csvHeaders,
      data,
      formatCsvRow
    })
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    downloadBlobAsFile(blob, `${csvFileName || titleSpaceReplacedWithUnderscore}.csv`)
  }

  if (asIcon) {
    return (
      <IconButton onClick={exportToCsV} data-testid={DOWNLOAD_CSV_BUTTON_TEST_ID}>
        <FileDownloadOutlinedIcon />
      </IconButton>
    )
  }

  return (
    <Button variant="outlined" onClick={exportToCsV} data-testid={DOWNLOAD_CSV_BUTTON_TEST_ID}>
      {DOWNLOAD_CSV_LABEL}
    </Button>
  )
}
